import { combineReducers } from 'redux-immutable'

import ui from './ui'
import data from './data'
import gaioData from './gaio_data'
import previous from './previous'
import gaioPrevious from './gaio_previous'
import aiChartAnalysis from './ai_chart_analysis'

export default combineReducers({
  ui,
  data,
  gaioData,
  previous,
  gaioPrevious,
  aiChartAnalysis
})
